"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const FlightDetailsHeaderWeb_1 = __importDefault(require("./FlightDetailsHeaderWeb"));
const TimelineRow_1 = __importDefault(require("../flight_overview/TimelineRow"));
const LocationRow_1 = __importDefault(require("./LocationRow"));
const FlightLocationTimelineSectionWeb = ({ flightData, more = false }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(FlightDetailsHeaderWeb_1.default, { flightData: flightData }), (0, jsx_runtime_1.jsx)(TimelineRow_1.default, { flightData: flightData }), (0, jsx_runtime_1.jsx)(LocationRow_1.default, { flightData: flightData, more: more })] }));
exports.default = FlightLocationTimelineSectionWeb;
